import { render } from "./adminDashboard.vue?vue&type=template&id=22007476&scoped=true&ts=true"
import script from "./adminDashboard.vue?vue&type=script&lang=ts"
export * from "./adminDashboard.vue?vue&type=script&lang=ts"

import "./adminDashboard.vue?vue&type=style&index=0&id=22007476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22007476"]])

export default __exports__